import type { ComponentProps } from 'react';
import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { ClientRender } from '@change-corgi/core-react/ssr/render';
import { useCurrentBreakpointValue } from '@change-corgi/design-system-legacy/responsive';

import { LazyComponent } from '#src/app/shared/components/layout/lazy';

import type { ShareContainer } from './Share';

async function loadShare(): Promise<typeof ShareContainer> {
	return (await import(/* webpackChunkName: "pages/petition_details_share" */ './Share')).ShareContainer;
}

const ShareLoaderInner: React.FC<ComponentProps<typeof ShareContainer>> = (props) => {
	return <LazyComponent loadComponent={loadShare} fallback={<Spinner className="mx-auto mt-16 size-6" />} {...props} />;
};

const ShareLoaderForDesktopView: React.FC<ComponentProps<typeof ShareContainer>> = ({
	forMobileView,
	...restProps
}) => {
	const desktop = useCurrentBreakpointValue([false, true]);

	return desktop ? (
		<ShareLoaderInner forMobileView={forMobileView} {...restProps} />
	) : (
		<Spinner className="mx-auto mt-16 size-6" />
	);
};

export const ShareLoader: React.FC<ComponentProps<typeof ShareContainer>> = ({ forMobileView, ...restProps }) => {
	if (forMobileView) {
		return <ShareLoaderInner forMobileView={forMobileView} {...restProps} />;
	}

	return (
		<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
			<ShareLoaderForDesktopView forMobileView={forMobileView} {...restProps} />
		</ClientRender>
	);
};

export const preloadShare = loadShare;
